<template>

    <div class="progress-monitor-step-5">

        <p>
            Select an outcome goal — the minimum level that the student must
            achieve by the end of the intervention period to judge the
            intervention a success. Choose one of these three options:
        </p>

        <!-- Single Snap-Shot option -->

        <b-card no-body class="mb-3">
            <b-card-header>
                <b-form-radio v-model="docData.goalOption"
                              value="1">
                    Option 1: Single Snap-Shot
                </b-form-radio>
            </b-card-header>
            <b-card-body v-if="docData.goalOption == 1">
                <p>
                    Enter a single value that will define a successful outcome
                    if the student attains it by the end of the intervention period.
                </p>
                <b-form-group>
                    <label>
                        The minimum goal for success is
                    </label>
                    <b-input-group :append="docData.formatTitle">
                        <b-form-input type="number"
                                      v-model="docData.goalMinimum"
                                      :min="docData.formatMin"
                                      :max="docData.formatMax"/>
                    </b-input-group>
                </b-form-group>

                <b-alert variant="danger"
                         :show="docData.goalMinimum < docData.formatMin || docData.goalMinimum > docData.formatMax">
                    Value must be between {{ docData.formatMin }} and {{ docData.formatMax }}
                </b-alert>
            </b-card-body>
        </b-card>

        <!-- Median Average option -->

        <b-card no-body class="mb-3">
            <b-card-header>
                <b-form-radio v-model="docData.goalOption"
                              value="2">
                    Option 2: Median Average
                </b-form-radio>
            </b-card-header>
            <b-card-body v-if="docData.goalOption == 2">
                <p>
                    To control for variability in the data,
                    select a minimum value that represents a successful intervention
                    and decide how many of the final data-points will be used to
                    calculate the student's MEDIAN performance.
                </p>
                <b-form-group>
                    <label>
                        The minimum goal for success is
                    </label>
                    <b-input-group :append="docData.formatTitle">
                        <b-form-input type="number"
                                      v-model="docData.goalMinimum"
                                      :min="docData.formatMin"
                                      :max="docData.formatMax"/>
                    </b-input-group>
                </b-form-group>

                <b-alert variant="danger"
                         :show="docData.goalMinimum < docData.formatMin || docData.goalMinimum > docData.formatMax">
                    Value must be between {{ docData.formatMin }} and {{ docData.formatMax }}
                </b-alert>

                <b-form-group>
                    <label>
                        The number of data points to be used to calculate MEDIAN student performance will be
                    </label>
                    <b-form-input type="number"
                                  v-model="docData.goalDataPoints"/>
                </b-form-group>
            </b-card-body>
        </b-card>

        <!-- Mean Average option -->

        <b-card no-body class="mb-3">
            <b-card-header>
                <b-form-radio v-model="docData.goalOption"
                              value="3">
                    Option 3: Mean Average
                </b-form-radio>
            </b-card-header>
            <b-card-body v-if="docData.goalOption == 3">
                <p>
                    To control for variability in the data,
                    select a minimum value that represents a successful intervention
                    and decide how many of the final data points will be used to
                    calculate the student's MEAN performance.
                </p>
                <b-form-group>
                    <label>
                        The minimum goal for success is
                    </label>
                    <b-input-group :append="docData.formatTitle">
                        <b-form-input type="number"
                                      v-model="docData.goalMinimum"
                                      :min="docData.formatMin"
                                      :max="docData.formatMax"/>
                    </b-input-group>
                </b-form-group>

                <b-alert variant="danger"
                         :show="docData.goalMinimum < docData.formatMin || docData.goalMinimum > docData.formatMax">
                    Value must be between {{ docData.formatMin }} and {{ docData.formatMax }}
                </b-alert>

                <b-form-group>
                    <label>
                        The number of data points to be used to calculate MEAN student performance will be
                    </label>
                    <b-form-input type="number"
                                  v-model="docData.goalDataPoints"/>
                </b-form-group>
            </b-card-body>
        </b-card>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ProgressMonitorStep5",
        mixins: [ToolMixin],
        // computed: {
        //     thisStepIsValid() {
        //         const fields = [
        //             this.docData.goalMinimum
        //         ]
        //         return _.every(fields, (f) => {
        //             return f != '' && !_.isNil(f)
        //         })
        //     }
        // },
    })

</script>


